export default __webpack_public_path__ + "static/media/cards-active.84e64690.svg";